export default {
    APP_VIEW__START_CHAT: "startChat",
    APP_VIEW__CHAT_INTERFACE: "chatInterface",

    ORIGIN_ID__PROTEUS: 1,

    CHAT_MESSAGE_ROLE__USER: "user",
    CHAT_MESSAGE_ROLE__ASSISTANT: "assistant",

    ESCALATION_DECISION__NONE: "-",
    ESCALATION_DECISION__CONTINUE: "continue",
    ESCALATION_DECISION__ESCALATE: "escalate",

    ESCALATION_OPTION__COMMUNITY: "community",
    ESCALATION_OPTION__TICKET: "ticket",
    ESCALATION_OPTION__LIVECHAT: "livechat",

    DEFAULT_AVATAR: "https://gravatar.com/avatar/?s=48&d=mp"
} 